export default "__VITE_ASSET__m3f7orTd__"